import React from 'react'
import cartItemFragment from '@data/fragments/cartFragment/cartItemFragment'
import formatNumber from '@i18n/formatNumber'
import FormatNumber from '@i18n/formatNumber/Component'
import classnames from 'classnames'
import {TFunction, withTranslation} from 'next-i18next'

import Amount from './Amount'
import Options from './Options'
import Update from './Update'

import styles from './styles.module.css'

export interface ItemProps {
  item: any
  readOnly: boolean
  showOptions: boolean
  smallPadding: boolean
  amountClassname: string
  preferences?: any
  t: TFunction
}

export class Item extends React.Component<ItemProps> {
  static defaultProps = {
    showOptions: true,
    smallPadding: false
  }

  static fragment = cartItemFragment

  getBenefitByItem() {
    const {item} = this.props
    const benefits = this.props?.preferences?.cart?.benefits

    return benefits?.find(({productId}) => productId === item?.product?._id)
  }

  renderPrice() {
    const {unitPrice, realPrice, amount} = this.props.item
    const benefit = this.getBenefitByItem()

    if (unitPrice === null) return 'No disponible'
    if (realPrice === unitPrice && !benefit) {
      return <FormatNumber value={unitPrice * amount} />
    }
    if (realPrice !== unitPrice && !benefit) {
      return (
        <span>
          <span className={styles.realPrice}>{formatNumber(realPrice * amount, 'money')}</span>
          <FormatNumber value={unitPrice * amount} />
        </span>
      )
    }
    if (benefit && benefit?.totalPriceWithBenefit) {
      return (
        <span>
          <span className={styles.realPrice}>{formatNumber(realPrice * amount, 'money')}</span>
          <FormatNumber value={benefit?.totalPriceWithBenefit} />
        </span>
      )
    }
  }

  render() {
    const {readOnly, item, amountClassname} = this.props
    const {product, deletedAt} = item
    const isLoading = item && item._id && item._id.startsWith('pending')
    const containerStyle = this.props.smallPadding ? styles.smallPaddingContainer : styles.container

    return (
      <div className={isLoading ? styles.loading : containerStyle}>
        <div className={classnames(styles.head, deletedAt && styles.deleted)}>
          <div className={styles.amount}>
            <Amount item={this.props.item} readOnly={readOnly} amountClassname={amountClassname} />
          </div>
          <div className={styles.name}>
            {product.name}
            {deletedAt && (
              <div className={styles.deletedAt}>
                {this.props.t('fields.deleted', {ns: 'generic'})}
              </div>
            )}
          </div>

          <div className={styles.price}>{this.renderPrice()}</div>
        </div>
        {this.props.showOptions && (
          <div className={styles.bottom}>
            <Options item={this.props.item} />
            {readOnly ? null : (
              <div className={styles.editContainer}>
                <Update item={this.props.item} preferences={this.props.preferences} />
                {/* <Delete item={this.props.item} /> */}
              </div>
            )}
          </div>
        )}
        {item.outOfStockMessage ? (
          <div
            className={styles.outOfStock}
            dangerouslySetInnerHTML={{__html: item.outOfStockMessage}}></div>
        ) : null}
      </div>
    )
  }
}

export default withTranslation()(Item)
